module.exports = __webpack_public_path__ + "static/media/mark-icon-3.a0711b29.svg";